import { bridge } from '../../../bridge';
import { ABLY_INFO } from '../../../../constant/ablyInfo';

export const moveToHome = () => {
  bridge.openDeeplink('ably://home/today', {
    webCallback: () => {
      location.replace(ABLY_INFO.url);
    },
  });
};
